import { render, staticRenderFns } from "./ProductModelManagement.vue?vue&type=template&id=67a3583f&scoped=true"
import script from "./ProductModelManagement.vue?vue&type=script&lang=js"
export * from "./ProductModelManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductModelManagement.vue?vue&type=style&index=0&id=67a3583f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3583f",
  null
  
)

export default component.exports